import { FC, ReactNode } from 'react'
import { Box } from '@mantine/core'

const InviteAuthShell: FC<{ children: ReactNode }> = ({ children }) => (
  <Box bg="#F4F5F7" mih="100dvh" px={16} py={{ base: 24, sm: 56 }} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
    <Box
      bg="white"
      pt={{ base: 28, sm: 36 }}
      px={{ base: 20, sm: 36 }}
      pb={{ base: 24, sm: 28 }}
      w="100%"
      maw={460}
      style={{ borderRadius: 14, boxShadow: '0 1px 2px rgba(16,24,40,0.04), 0 12px 32px rgba(16,24,40,0.08)' }}
    >
      <Box mb={28} style={{ lineHeight: 0 }}>
        <img src="/logo-type-blue.svg" alt="ServCraft" style={{ height: 34, width: 'auto', display: 'block' }} />
      </Box>
      {children}
    </Box>
  </Box>
)

export default InviteAuthShell
